// React component

import { createContext, useContext, useState, ReactNode } from "react";

interface MaintenanceContextType {
  isInMaintenance: boolean;
  setIsInMaintenance: (value: boolean) => void;
}

const MaintenanceContext = createContext<MaintenanceContextType | undefined>(
  undefined,
);

export function MaintenanceProvider({ children }: { children: ReactNode }) {
  const [isInMaintenance, setIsInMaintenance] = useState(true);

  return (
    <MaintenanceContext.Provider
      value={{ isInMaintenance, setIsInMaintenance }}
      data-oid="k4gtl2t"
    >
      {children}
    </MaintenanceContext.Provider>
  );
}

export function useMaintenance() {
  const context = useContext(MaintenanceContext);
  if (context === undefined) {
    throw new Error("useMaintenance must be used within a MaintenanceProvider");
  }
  return context;
}
